import { DataModelAttribute } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import {
  DataModelAttributeEntity,
  DefaultUIAttributeType,
} from '@flowx/designer/shared/entities/data-model.entity'

import { GENERAL_VALIDATOR_TYPES } from '../components/data-model-attribute-validators/data-model-attribute-validators.constants'

type AttributeTypeInfo = Pick<DataModelAttribute, 'type' | 'multiInstance' | 'reference'>

export function toUiType(attribute: AttributeTypeInfo): DefaultUIAttributeType {
  return attribute.multiInstance
    ? DefaultUIAttributeType.ARRAY
    : DataModelAttributeEntity.mapDataModelTypeToUiType(attribute.type, !!attribute.reference)
}

export function removesTypeSpecificValidators(
  currentAttribute: (Pick<DataModelAttribute, 'validators'> & AttributeTypeInfo) | undefined,
  newAttribute: AttributeTypeInfo
): boolean {
  if (!currentAttribute) {
    return false
  }
  const hasTypeSpecificValidators = (currentAttribute.validators ?? []).some(
    (validator) => !GENERAL_VALIDATOR_TYPES.includes(validator.type)
  )
  return hasTypeSpecificValidators && toUiType(currentAttribute) !== toUiType(newAttribute)
}
